import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import UAVSphere_logo from "../assets/images/UAVspherelogo2.jpg";

import { history } from "_helpers";
import { userActions, alertActions } from "_store";

export { Register };

function Register() {
    const dispatch = useDispatch();
    const [isVerificationStep, setIsVerificationStep] = useState(false);
    const [email, setEmail] = useState("");

    // form validation rules
    const validationSchema = Yup.object().shape({
    // firstname: Yup.string()
    //     .required('First Name is required'),
    // lastname: Yup.string()
    //     .required('Last Name is required'),
    // company: Yup.string()
    //     .required('City Name is required'),
    // address: Yup.string()
    //     .required('City Name is required'),
    // city: Yup.string()
    //     .required('City Name is required'),
    // state: Yup.string()
    //     .required('City Name is required'),
    // country: Yup.string()
    //     .required('City Name is required'),
    // phonenumber: Yup.string()
    //     .required('City Name is required'),
        email: Yup.string().required("Email is required").email("Email is invalid"),
        password: Yup.string()
            .required("Password is required")
            .min(6, "Password must be at least 6 characters")
            .max(12, "Password cannot exceed more than 12 characters"),
        confirm_password: Yup.string()
            .required("Confirm Password is required")
            .min(6, "Password must be at least 6 characters")
            .max(12, "Password cannot exceed more than 12 characters")
            .oneOf([Yup.ref("password")], "Passwords do not match"),
        verification_code: isVerificationStep ? Yup.string().required("Verification code is required") : Yup.string().notRequired(),
    });
    const formOptions = { resolver: yupResolver(validationSchema) };

    // get functions to build form with useForm() hook
    const { register, handleSubmit, formState } = useForm(formOptions);
    const { errors, isSubmitting } = formState;

    async function onSubmit(data) {
        dispatch(alertActions.clear());

        if (!isVerificationStep) {
            // Initial registration
            try {
                const { email, password } = data;
                setEmail(email);
                await dispatch(userActions.register({ email, password })).unwrap();
                setIsVerificationStep(true); // Show verification step
            } catch (error) {
                dispatch(alertActions.error(error));
            }
        } else {
            // Verification step
            try {
                const { verification_code } = data;
                await dispatch(userActions.verify({ email, verification_code })).unwrap();

                // Redirect to login page and display success alert
                history.navigate("/account/login");
                dispatch(
                    alertActions.success({
                        message: "Verification successful, you can now log in",
                        showAfterRedirect: true,
                    })
                );
            } catch (error) {
                dispatch(alertActions.error("Invalid verification code"));
            }
        }
    }

    async function handleResendCode() {
        dispatch(alertActions.clear());

        try {
            const response = await dispatch(userActions.resendVerificationCode(email)).unwrap();
            dispatch(
                alertActions.success(response.message || "Verification code resent successfully.")
            );
        } catch (error) {
            dispatch(
                alertActions.error(error.message || "Failed to resend verification code.")
            );
        }
    }

    return (
        <div className="card m-3">
              <div className="text-center">
            <img 
                src={UAVSphere_logo} 
                alt="UAVSphere Logo" 
                style={{ width: '150px', height: 'auto' }} 
            />
        </div>
            <h4 className="card-header">Register</h4>
            <div className="card-body">
                <form onSubmit={handleSubmit(onSubmit)}>
          {/* <div className="mb-3">
                        <label className="form-label">First Name</label>
                        <input name="firstname" type="text" {...register('firstname')} className={`form-control ${errors.firstname ? 'is-invalid' : ''}`} />
                        <div className="invalid-feedback">{errors.firstname?.message}</div>
                    </div> */}
          {/* <div className="mb-3">
                        <label className="form-label">Last Name</label>
                        <input name="lastname" type="text" {...register('lastname')} className={`form-control ${errors.lastname ? 'is-invalid' : ''}`} />
                        <div className="invalid-feedback">{errors.lastname?.message}</div>
                    </div> */}
          {/* <div className="mb-3">
                        <label className="form-label">Company Name</label>
                        <input name="company" type="text" {...register('company')} className={`form-control ${errors.company ? 'is-invalid' : ''}`} />
                        <div className="invalid-feedback">{errors.company?.message}</div>
                    </div> */}
          {/* <div className="mb-3">
                        <label className="form-label">Address</label>
                        <input name="address" type="text" {...register('address')} className={`form-control ${errors.address ? 'is-invalid' : ''}`} />
                        <div className="invalid-feedback">{errors.address?.message}</div>
                    </div> */}
          {/* <div className="mb-3">
                        <label className="form-label">City Name</label>
                        <input name="city" type="text" {...register('city')} className={`form-control ${errors.city ? 'is-invalid' : ''}`} />
                        <div className="invalid-feedback">{errors.city?.message}</div>
                    </div> */}
          {/* <div className="mb-3">
                        <label className="form-label">State Name</label>
                        <input name="state" type="text" {...register('state')} className={`form-control ${errors.state ? 'is-invalid' : ''}`} />
                        <div className="invalid-feedback">{errors.state?.message}</div>
                    </div> */}
          {/* <div className="mb-3">
                        <label className="form-label">Country Name</label>
                        <input name="country" type="text" {...register('country')} className={`form-control ${errors.country ? 'is-invalid' : ''}`} />
                        <div className="invalid-feedback">{errors.country?.message}</div>
                    </div> */}
          {/* <div className="mb-3">
                        <label className="form-label">Phone Number</label>
                        <input name="phonenumber" type="text" {...register('phonenumber')} className={`form-control ${errors.phonenumber ? 'is-invalid' : ''}`} />
                        <div className="invalid-feedback">{errors.phonenumber?.message}</div>
                    </div> */}
                    {!isVerificationStep && (
                        <>
                            <div className="mb-3">
                                <label className="form-label">Email</label>
                                <input
                                    name="email"
                                    type="email"
                                    placeholder="Enter Email"
                                    {...register("email")}
                                    className={`form-control ${errors.email ? "is-invalid" : ""}`}
                                />
                                <div className="invalid-feedback">{errors.email?.message}</div>
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Password</label>
                                <input
                                    name="password"
                                    type="password"
                                    placeholder="Enter Password"
                                    {...register("password")}
                                    className={`form-control ${errors.password ? "is-invalid" : ""}`}
                                />
                                <div className="invalid-feedback">{errors.password?.message}</div>
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Confirm Password</label>
                                <input
                                    name="confirm_password"
                                    type="password"
                                    placeholder="Enter Confirm Password"
                                    {...register("confirm_password")}
                                    className={`form-control ${errors.confirm_password ? "is-invalid" : ""}`}
                                />
                                <div className="invalid-feedback">{errors.confirm_password?.message}</div>
                            </div>
                        </>
                    )}

                    {isVerificationStep && (
                        <>
                            <div className="mb-3">
                                <label className="form-label">Verification Code</label>
                                <input
                                    name="verification_code"
                                    type="text"
                                    placeholder="Enter Verification Code"
                                    {...register("verification_code")}
                                    className={`form-control ${errors.verification_code ? "is-invalid" : ""}`}
                                />
                                <div className="invalid-feedback">{errors.verification_code?.message}</div>
                            </div>
                            <button
                                type="button"
                                className="btn btn-primary  me-2"
                                onClick={handleResendCode}
                            >
                                Resend Code
                            </button>
                        </>
                    )}

                    <div className="auth-button-stack">
  <button disabled={isSubmitting} className="btn btn-primary">
    {isSubmitting && (
      <span className="spinner-border spinner-border-sm me-1"></span>
    )}
    {isVerificationStep ? "Verify" : "Register"}
  </button>

  {!isVerificationStep && (
    <Link to="../login" className="btn btn-secondary">Cancel</Link>
  )}
</div>
                </form>
            </div>
        </div>
    );
}
	